import React from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { MapPin, Navigation } from "lucide-react";
import { naira, StateBadge } from "./appHelpers";

const NEXT = {
  BID_ACCEPTED: { label: "Start heading to pickup", state: "DRIVER_EN_ROUTE" },
  DRIVER_EN_ROUTE: { label: "I've arrived", state: "DRIVER_ARRIVED" },
  DRIVER_ARRIVED: { label: "Start trip", state: "TRIP_STARTED" },
  TRIP_STARTED: { label: "Trip in progress", state: "TRIP_IN_PROGRESS" },
  TRIP_IN_PROGRESS: { label: "Complete trip", state: "TRIP_COMPLETED" },
};
const inputCls = "h-10 bg-[#0a0e0c] border-white/15 text-white focus-visible:ring-[#2fd645]";

export function OpenRideCard({ ride: r, amount, onAmount, onBid }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-[#0e1311] p-4">
      <div className="flex items-center justify-between text-sm text-white/80">
        <span className="flex items-center gap-1"><MapPin className="h-4 w-4 text-[#2fd645]" /> {r.pickup} → {r.destination}</span>
        <span className="text-white/50">{r.category}</span>
      </div>
      <div className="mt-1 text-xs text-white/50">{r.distance_km} km · ~{r.duration_min} min · passenger offers <b className="text-white">{naira(r.proposed_fare)}</b></div>
      <div className="mt-3 flex items-center gap-2">
        <Input data-testid={`bid-input-${r.id}`} className={inputCls} inputMode="numeric" placeholder={`Bid (e.g. ${r.proposed_fare})`} value={amount || ""} onChange={(e) => onAmount(r.id, e.target.value.replace(/\D/g, ""))} />
        <Button data-testid={`bid-submit-${r.id}`} onClick={() => onBid(r.id)} className="h-10 px-4 bg-[#2fd645] text-[#06210b] font-bold rounded-lg">Bid</Button>
        <Button data-testid={`bid-accept-offer-${r.id}`} onClick={() => onAmount(r.id, String(r.proposed_fare))} variant="outline" className="h-10 px-3 border-white/20 text-white/80 rounded-lg">Accept offer</Button>
      </div>
    </div>
  );
}

export function ActiveTripCard({ ride: r, onStep }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-[#0e1311] p-5">
      <div className="flex items-center justify-between"><StateBadge state={r.state} /><span className="font-bold text-[#2fd645]">{naira(r.final_fare || r.proposed_fare)}</span></div>
      <div className="mt-3 flex items-center gap-2 text-sm text-white/80"><Navigation className="h-4 w-4 text-[#2fd645]" /> {r.pickup} → {r.destination}</div>
      <div className="mt-1 text-xs text-white/50">Passenger: {r.passenger_name} · {r.distance_km} km</div>
      {NEXT[r.state] && (
        <Button data-testid={`trip-next-${r.id}`} onClick={() => onStep(r.id, NEXT[r.state].state)} className="mt-4 w-full h-11 bg-[#2fd645] text-[#06210b] font-bold rounded-xl">
          {NEXT[r.state].label}
        </Button>
      )}
      {["BID_ACCEPTED", "DRIVER_EN_ROUTE", "DRIVER_ARRIVED"].includes(r.state) && (
        <button data-testid={`trip-cancel-${r.id}`} onClick={() => onStep(r.id, "DRIVER_CANCELLED")} className="mt-2 text-xs text-white/40 hover:text-red-400">Cancel trip</button>
      )}
    </div>
  );
}
